import { FuelIcon, FuelTypography } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const MenuTitle = styled(FuelTypography).attrs({ weight: 'bold', size: 'body-lg' })`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
`

export const ArrowDropdown = styled(FuelIcon).attrs({ name: 'arrow-dropdown', size: 'medium' })`
  top: 4px;
`
